import React, {memo, useContext, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Button, Col, Row} from "react-bootstrap";

import Ticket from './Ticket';
import Receipt from './Receipt';
import TicketMenu from './Ticket/TicketMenu';
import ReceiptMenu from './Receipt/ReceiptMenu';
import {UserContext} from "../context";
import {wsUrl} from "../constants";
import Loader from "./Loader";

const PaymentDetails = ({paymentId, onCancelPayment}) => {
  const location = useLocation();
  const [tickets, setTickets] = useState([]);
  const [checkboxReceipt, setCheckboxReceipt] = useState(null);
  const [ticketsToPrint, setTicketsToPrint] = useState([]);
  const [toPrintReceipt, setToPrintReceipt] = useState(true);

  const autoPrint = parseInt(new URLSearchParams(location.search).get('print'));

  const user = useContext(UserContext);

  useEffect(() => {
    (async () => {
      const token = window.sessionStorage.getItem('token');
      const response = await fetch(`/payment/cash/?payment_id=${paymentId}`, {
        headers: {'Authorization': `Token ${token}`,}
      });
      if (response.status === 200) {
        const responseJson = await response.json();
        await setTickets(responseJson.tickets);
        await setTicketsToPrint(responseJson.tickets);
        await setCheckboxReceipt(responseJson.checkbox_receipt);
        if (autoPrint && !responseJson.checkbox_receipt) {
            printTickets();
        }
      }
    })();
  }, []);

  useEffect(() => {
    if (checkboxReceipt && !checkboxReceipt.html) {
      setTimeout(() => getCheckboxReceipt(checkboxReceipt.checkbox_id), 1000)
    }
  }, [checkboxReceipt])

  const onPrintButtonPress = () => printTickets(tickets);

  const printTickets = () => window.print();

  const printTicket = async (ticket) => {
    await setTicketsToPrint(tickets.filter(t => t.number === ticket.number));
    await setToPrintReceipt(false);
    window.print();
    await setToPrintReceipt(true);
    await setTicketsToPrint(tickets);
  };

  const printReceipt = async () => {
    await setTicketsToPrint([]);
    await setToPrintReceipt(true);
    window.print();
    await setTicketsToPrint(tickets);
  };

  const cancelTicket = async (ticket) => {
    if (window.confirm('Ви дійсно бажаєте анулювати квиток?')) {
      const token = window.sessionStorage.getItem('token');
      const response = await fetch(`/ticket/${ticket.number}/`, {
        method: 'DELETE',
        headers: {'Authorization': `Token ${token}`,}
      });
      if (response.status === 200) {
        window.location.replace(window.location.pathname);
      } else {
        const responseJson = await response.json();
        window.alert(responseJson);
      }
    }
  };

  const getCheckboxReceipt = (checkboxId) => {
    const token = window.sessionStorage.getItem('token');
    const ws = new WebSocket(`${wsUrl}/checkbox_shift`);
    ws.onopen = () => {
      ws.send(JSON.stringify({
        method: 'receipt_status',
        cash_desk: localStorage.getItem('каса'),
        user_id: user.id,
        checkbox_id: checkboxId,
        token,
      }));
    };

    ws.onerror = () => console.log({error: 'Помилка роботи запиту.'});

    ws.onmessage = async function (evt) {
      const message = JSON.parse(evt.data);
      if (message.error) {
        console.log('error', message.error);
      } else if (message.result) {
        setCheckboxReceipt(r => ({...r, html: message.result}));
        autoPrint && printTickets();
      }
      ws.close(1000, 'OK');
    };
  }

  if (checkboxReceipt && !checkboxReceipt.html) {
    return (
      <div
        className='d-flex justify-content-center'
        style={{paddingBottom: '15px'}}
      >
        <Loader/>
      </div>
    )
  }

  return (
    <>
      <div
        className='d-flex justify-content-end'
        style={{paddingBottom: '15px'}}
      >
        <Button
          variant="outline-secondary"
          onClick={onPrintButtonPress}
        >Друк</Button>
        {!checkboxReceipt && (
          <Button
            variant="outline-danger"
            onClick={() => onCancelPayment(paymentId)}
          >Відміна</Button>
        )}
      </div>
      <Row className='tickets-wrapper'>
        {ticketsToPrint.map(ticket => (
          <Col
            sm={6}
            md={4}
            lg={3}
            key={ticket.number}
          >
            <Ticket
              {...ticket}
            />
            <TicketMenu
              onPrintButtonPress={() => printTicket(ticket)}
              onCancelTicketPress={() => cancelTicket(ticket)}
              // showCancelButton={ticket.status !== 'Анульований'}
            />
          </Col>
        ))}
        {checkboxReceipt && checkboxReceipt.html && toPrintReceipt && (
          <Col
            sm={6}
            md={4}
            lg={3}
            key={checkboxReceipt.checkbox_id}
          >
            <Receipt
              receipt={checkboxReceipt}
              toPrint={toPrintReceipt}
              onPrintButtonPress={printReceipt}
            />
            <ReceiptMenu onPrintButtonPress={printReceipt}/>
          </Col>
        )}
      </Row>
    </>
  )
};

export default memo(PaymentDetails);
